export default __webpack_public_path__ + "static/media/creative_mob.dde88945.svg";